<div class="login-container">

    <!-- Background Effects -->
    <div class="bg-effects">
        <div class="bg-radial bg-radial-1"></div>
        <div class="bg-radial bg-radial-2"></div>
        <div class="bg-pattern"></div>
    </div>

    <!-- Loading Spinner -->
    <div class="spin_block" *ngIf="isload">
        <div class="spinner-border text-light"></div>
    </div>

    <div class="split-layout" *ngIf="!isload">
        
        <!-- Left Column: Brand & Overview -->
        <div class="left-panel">
            <div class="brand-header">
                <!-- User's Existing Logo inside the new logo-wrapper -->
                <div class="logo-wrapper">
                    <img src="assets/img/logo-rajhair.png" class="brand-logo" alt="Logo">
                </div>
            </div>

            <div class="visual-card">
                <div class="visual-overlay"></div>
                <!-- User's Image Slider Maintained -->
                <div class="image-slider">
                  <img
                    *ngFor="let image of images; let i = index"
                    [src]="image"
                    [class.active]="i === currentImage"
                    class="slider-image"
                    alt="Asset Tracking">
                </div>
            </div>

            <div class="overview-content">
                <p class="tagline">Smart, Secure & Intelligent Asset Lifecycle Management for your organization.</p>

                <div class="feature-grid">
                    <div class="feature-card">
                        <div class="icon"><i class='bx bx-layer'></i></div>
                        <div class="feature-text">
                            <h5>Asset Master</h5>
                            <span>Centralized Records</span>
                        </div>
                    </div>
                    <div class="feature-card">
                        <div class="icon"><i class='bx bx-barcode'></i></div>
                        <div class="feature-text">
                            <h5>Barcode Tracking</h5>
                            <span>Scan & Track Instantly</span>
                        </div>
                    </div>
                    <div class="feature-card">
                        <div class="icon"><i class='bx bx-refresh'></i></div>
                        <div class="feature-text">
                            <h5>Issue & Return</h5>
                            <span>Employee Asset Movement</span>
                        </div>
                    </div>
                    <div class="feature-card">
                        <div class="icon"><i class='bx bx-bar-chart-alt-2'></i></div>
                        <div class="feature-text">
                            <h5>Reports</h5>
                            <span>Analytics & Dashboard</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Right Column: Login Card -->
        <div class="right-panel">
            <div class="login-card">
                <div class="card-accent-line"></div>
                
                <div class="card-header">
                    <h2>Asset Tracking System</h2>
                    <p>Sign in to continue</p>
                </div>

                <div class="form-wrapper">
                    <!-- Username -->
                    <div class="form-group">
                        <label>User Name</label>
                        <div class="input-box">
                            <i class="bx bx-user input-icon"></i>
                            <input
                                type="text"
                                class="form-control"
                                [(ngModel)]="addD.Username"
                                name="Username"
                                placeholder="Enter User Name"
                                (keyup.enter)="focus_Next()">
                        </div>
                    </div>

                    <!-- Password -->
                    <div class="form-group">
                        <label>Password</label>
                        <div class="input-box">
                            <i class="bx bx-lock-alt input-icon"></i>
                            <input
                                [type]="showPassword ? 'text':'password'"
                                class="form-control"
                                [(ngModel)]="addD.Password"
                                name="Password"
                                placeholder="Enter Password">
                            <i
                                class="bx eye-icon"
                                [ngClass]="showPassword ? 'bx-hide':'bx-show'"
                                (click)="togglePassword()">
                            </i>
                        </div>
                    </div>

                    <!-- Branch -->
                    <div class="form-group">
                        <label>Branch</label>
                        <div class="input-box">
                            <i class="bx bx-building input-icon"></i>
                            <select
                                class="form-control select-control"
                                [(ngModel)]="addD.Branch"
                                name="Branch">
                                <option value="" class="select-option">-- Select Branch --</option>
                                <option *ngFor="let b of branchList" [value]="b.bm_id" class="select-option">
                                    {{ b.bm_branch_name }}
                                </option>
                            </select>
                            <i class="bx bx-chevron-down chevron-icon"></i>
                        </div>
                    </div>

                    <button
                        class="login-btn"
                        (click)="login()"
                        [disabled]="btndisable">
                        <span
                            *ngIf="btndisable"
                            class="spinner-border spinner-border-sm me-2">
                        </span>
                        Login
                    </button>
                </div>
            </div>
        </div>

    </div>
</div>